export default __webpack_public_path__ + "static/media/Weelz-English-White.f6061571.png";